import { render, staticRenderFns } from "./ChatMembers.vue?vue&type=template&id=a1020ff2&scoped=true&lang=pug"
import script from "./ChatMembers.vue?vue&type=script&lang=js"
export * from "./ChatMembers.vue?vue&type=script&lang=js"
import style0 from "./ChatMembers.vue?vue&type=style&index=0&id=a1020ff2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1020ff2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1020ff2')) {
      api.createRecord('a1020ff2', component.options)
    } else {
      api.reload('a1020ff2', component.options)
    }
    module.hot.accept("./ChatMembers.vue?vue&type=template&id=a1020ff2&scoped=true&lang=pug", function () {
      api.rerender('a1020ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/modules/dashboard/ChatMembers.vue"
export default component.exports